<app-view-title [showBack]="false" [showHeader]="false" [isSplitColor]="false"></app-view-title>
<view-content [centered]="true" [nopadding]="true" class="image-background">

  <div style="display: flex; justify-content: center; align-items: center; height: 900px; margin-bottom: -110px; background-size:cover" [ngStyle]=" { 'background-image' : backgroundImageUri }">
    <div class="landing-page-container black-border-input" >
      <!-- Location-->
      <mat-form-field appearance="outline" style="z-index:10 ;height:100%">
        <mat-label>{{ 'Intellitrailer.Booking.WebLandingPage.Location' | translate : 'Location' }}</mat-label>
        <input type="text"
               matInput
               #search
               [(ngModel)]="location"
               (focus)="filterLocations()"
               (input)="filterLocations()">

        @if (searchedOnLocation) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearLocationInput()">
          <mat-icon>close</mat-icon>
        </button>
        }

        @if(searchedOnLocation && selectedLocation == null){
        <div class="dropdown-container" #dropdownContainer (keydown)="handleKeyDown($event)" tabindex="0">
          <!--List of locations-->
          <div class="locations-list" (keydown)="handleKeyDown($event)">
            <mat-option *ngFor="let location of filteredLocationsList"
                        [value]="location.Name"
                        (mouseenter)="setHoveredLocation(location)"
                        [ngClass]="{'hovered': hoveredLocation?.Name === location.Name}"
                        (click)="selectLocation(location)">
              {{ location.Name }}
            </mat-option>
          </div>
          <!--Details Box-->
          <div class="details-box" *ngIf="hoveredLocation" style="background-color:#f0f0f0">
            <h3> <mat-icon>location_on</mat-icon>  {{ hoveredLocation.Name }}</h3>
            <p style="font-size:12px; color:gray;">{{ hoveredLocation.Address }}, {{ hoveredLocation.City }} {{ hoveredLocation.ZipCode }}, {{hoveredLocation.Country}}</p>
            <br />
            <p style="white-space:pre-wrap" *ngIf="hoveredLocation.OpenHours">{{ hoveredLocation.OpenHours }}</p>
            <p *ngIf="!hoveredLocation.OpenHours">{{ 'Intellitrailer.Booking.WebLandingPage.OpenAroundTheClock' | translate : 'Open around the clock' }}</p>
          </div>

          <mat-icon style="position: absolute; inset-inline-end: 5px; top: 5px;" (click)="searchedOnLocation = false">close</mat-icon>
        </div>
        }
      </mat-form-field>

      <!-- RentalObjectType -->
      <mat-form-field appearance="outline" style="width:70%; height:100%">
        <mat-label>{{ 'Intellitrailer.Booking.WebLandingPage.Categories' | translate : 'Categories' }} </mat-label>
        <mat-select #categoriesSelect [(value)]="selectedType">
          <mat-option *ngFor="let category of filterdCategoryList" [value]="category" [disabled]="category.disabled">
            @if(category?.ImageUri != ""){
            <img [src]="category.ImageUri" class="category-img" />
            }
            {{ 'Intellitrailer.Booking.WebLandingPage.CategoryList_' + category.Id + '_' + category.ContextId | translate : category.Name }}

          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Start Date & Time -->
      <!-- Pickup -->
      <mat-form-field appearance="outline" style="width:55%">
        <mat-label>{{ 'Intellitrailer.Booking.WebLandingPage.StartDate' | translate : 'Start date' }}</mat-label>
        <input matInput [matDatepicker]="startPicker" [ngModel]="pickupDate" (ngModelChange)="updatePickupDate($event)" [min]="minDate">
        <mat-datepicker-toggle matIconSuffix [for]="startPicker">
          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width:45%">
        <mat-label>{{ 'Intellitrailer.Booking.WebLandingPage.PickupTime' | translate : 'Pickup time' }}</mat-label>
        <input matInput
               [matTimepicker]="pickupTimePicker"
               [matTimepickerMin]="pickupStartLimit"
               [matTimepickerMax]="pickupEndLimit"
               [ngModel]="pickupTime"
               (ngModelChange)="onPickupTimeChange($event)">
        <mat-timepicker-toggle matIconSuffix [for]="pickupTimePicker" />
        <mat-timepicker interval="30min" #pickupTimePicker />
      </mat-form-field>

      <!-- Return-->
      <mat-form-field appearance="outline" style="width:55%" *ngIf="bookOverNight">
        <mat-label>{{ 'Intellitrailer.Booking.WebLandingPage.EndDate' | translate : 'End date' }}</mat-label>
        <input matInput [min]="pickupDate" [matDatepicker]="returnPicker" [(ngModel)]="returnDate" (ngModelChange)="onReturnTimeChange()">
        <mat-datepicker-toggle matIconSuffix [for]="returnPicker">
          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #returnPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width:45%">
        <mat-label>{{ 'Intellitrailer.Booking.WebLandingPage.ReturnTime' | translate : 'Return time' }}</mat-label>
        <input matInput
               [matTimepicker]="returnTimePicker"
               [matTimepickerMin]="returnStartLimit"
               [matTimepickerMax]="returnEndLimit"
               [(ngModel)]="returnTime">

        @if(!bookOverNight){
        <mat-hint style="cursor:pointer; padding-inline-start:20%;"><a style="text-decoration:underline;" (click)="toggleOverNight()">{{ 'Intellitrailer.Booking.WebLandingPage.RentOvernight' | translate : 'Rent overnight' }}</a></mat-hint>
        }
        <mat-timepicker-toggle matIconSuffix [for]="returnTimePicker" />
        <mat-timepicker interval="30min" #returnTimePicker />
      </mat-form-field>

      <button (click)="searchOnData()" [disabled]="!isBookingTimeValid" class="custom-button">{{ 'Intellitrailer.Booking.WebLandingPage.Continue' | translate : 'Continue' }}</button>
    </div>
    <div>
    </div>
  </div>

</view-content>

<view-actions mode="transparent">
  <button mat-raised-button (click)="goToMap()">{{ 'Intellitrailer.Booking.WebLandingPage.SearchOnMap' | translate : 'Search on map' }}</button>
</view-actions>
